// удаление скролла при открытии модальных окон (для сафари)
// position: fixed сбрасывает scrollY в 0, поэтому сохраняем позицию и восстанавливаем
export function removeModalScrollSafari(isRemoveModal: boolean) {
  if (isRemoveModal) {
    const scrollY = window.scrollY
    document.body.style.top = `-${scrollY}px`
    document.body.classList.add('modal-open')
    return
  }

  const scrollY = document.body.style.top
  document.body.classList.remove('modal-open')
  document.body.style.top = ''
  window.scrollTo(0, parseInt(scrollY || '0', 10) * -1)
}
